import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../services/api';
import { FEEDBACK as S } from '../constants/strings';

const TABS = [
  { key: 'bug',  label: S.tabBug },
  { key: 'idea', label: S.tabIdea },
];

export default function Feedback() {
  const [searchParams] = useSearchParams();
  const [tab, setTab]         = useState('bug');
  const [name, setName]       = useState('');
  const [email, setEmail]     = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus]   = useState(null); // null | 'sending' | 'ok' | 'error'
  const [errMsg, setErrMsg]   = useState('');

  useEffect(() => {
    const t = searchParams.get('tab');
    if (t && TABS.find(x => x.key === t)) setTab(t);
  }, [searchParams]);

  function reset() {
    setName('');
    setEmail('');
    setMessage('');
    setStatus(null);
    setErrMsg('');
  }

  function handleTabChange(key) {
    setTab(key);
    reset();
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus('sending');
    setErrMsg('');
    try {
      await api.submitFeedback(tab, name, email, message);
      setStatus('ok');
    } catch (err) {
      setStatus('error');
      setErrMsg(err.message || S.errorGeneric);
    }
  }

  const successMsg = tab === 'bug' ? S.successBug : S.successIdea;

  return (
    <div className="fb-wrap">
      <div className="fb-header">
        <h1 className="fb-title">{S.pageTitle}</h1>
        <p className="fb-sub">{S.pageSub}</p>
      </div>

      <div className="fb-card">
        {/* Tab-Leiste */}
        <div className="fb-tabs" role="tablist">
          {TABS.map(t => (
            <button
              key={t.key}
              role="tab"
              aria-selected={tab === t.key}
              className={'fb-tab' + (tab === t.key ? ' active' : '')}
              onClick={() => handleTabChange(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>

        {/* Erfolgs-State */}
        {status === 'ok' ? (
          <div className="fb-success">
            <span className="fb-success-icon">🦉</span>
            <p>{successMsg}</p>
            <button className="fb-btn-ghost" onClick={reset}>Weiteres Feedback</button>
          </div>
        ) : (
          <form className="fb-form" onSubmit={handleSubmit} noValidate>

            {/* Name */}
            <div className="fb-field">
              <label className="fb-label">{S.labelName}</label>
              <input
                className="fb-input"
                type="text"
                value={name}
                onChange={e => setName(e.target.value)}
                placeholder={S.placeholderName}
                maxLength={100}
              />
            </div>

            {/* E-Mail */}
            <div className="fb-field">
              <label className="fb-label">{S.labelEmail}</label>
              <input
                className="fb-input"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder={S.placeholderEmail}
                maxLength={200}
              />
            </div>

            {/* Nachricht */}
            <div className="fb-field">
              <label className="fb-label">
                {S.labelMessage}
                <span className="fb-required"> *</span>
              </label>
              <textarea
                className="fb-input fb-textarea"
                value={message}
                onChange={e => setMessage(e.target.value)}
                placeholder={tab === 'bug' ? S.placeholderBug : S.placeholderIdea}
                required
                rows={5}
                maxLength={2000}
              />
            </div>

            {/* Fehler */}
            {status === 'error' && (
              <p className="fb-error">{errMsg || S.errorGeneric}</p>
            )}

            <button
              className="fb-btn-primary"
              type="submit"
              disabled={status === 'sending'}
            >
              {status === 'sending' ? S.btnSending : S.btnSend}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
